import { render, staticRenderFns } from "./historicalApproval.vue?vue&type=template&id=02bd2976&scoped=true"
import script from "./historicalApproval.vue?vue&type=script&lang=js"
export * from "./historicalApproval.vue?vue&type=script&lang=js"
import style0 from "./historicalApproval.vue?vue&type=style&index=0&id=02bd2976&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02bd2976",
  null
  
)

export default component.exports